import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ColoredUserAvatar from '../../../components/ColoredUserAvatar';
import BeworksAgentAvatar from '../../../components/BeworksAgentAvatar';
import { getServedByName } from '../utils/leadServedBy';

// Nunca temos foto do lead — o avatar representa quem está atendendo:
// o vendedor (cor derivada do nome) ou o Agente Beworks (IA).
const LeadAssignedAvatar = ({ assignedToName, lastAssignedToName, status, sx }) => {
  const { t } = useTranslation();
  const servedByName = getServedByName({ assignedToName, lastAssignedToName, status });

  if (servedByName) {
    return (
      <Tooltip title={servedByName}>
        {/* span: ColoredUserAvatar não repassa ref, o Tooltip precisa de um filho que aceite. */}
        <span>
          <ColoredUserAvatar name={servedByName} sx={sx} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('leads.servedByAI')}>
      <BeworksAgentAvatar sx={sx} />
    </Tooltip>
  );
};

export default LeadAssignedAvatar;
